export default __webpack_public_path__ + "static/media/ax99.029e1ad5.webp";